import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const BackNav = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white h-12 flex items-center border-b">
      <button
        onClick={() => navigate(-1)}
        className="h-full px-4 flex items-center hover:bg-gray-50 gap-2"
        title="Torna indietro"
      >
        <ArrowLeft className="w-5 h-5 text-gray-600" />
        <span className="text-gray-600">Indietro</span>
      </button>
    </div>
  );
};

export default BackNav;